import React from 'react';
import { withTheme } from '../ThemeProvider';
import styles from './ActionIcon.module.less';

const ActionIcon = ({ children, onPress }) => {
  return (
    <div
      className={styles.container}
      onClick={() => {
        onPress();
      }}
    >
      {children}
    </div>
  );
};

ActionIcon.displayName = 'ActionIcon';

export default withTheme(ActionIcon);
